import styled from '@emotion/styled';

import * as c from '@identity/constants';
import { remCalc } from '@lib/styleMethods';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;

  ${c.TABLET} {
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;

  img {
    -webkit-filter: grayscale(50%); /* Safari 6.0 - 9.0 */
    filter: grayscale(50%);
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  z-index: 1000;
  width: 100%;
  padding-bottom: 25px;

  figure {
    padding: 0 7vw;
  }

  svg {
    height: 200px;

    ${c.TABLET} {
      padding-bottom: 0;
      height: 320px;
    }

    ${c.DESKTOP} {
      height: 400px;
    }

    ${c.DESKTOP_HD} {
      height: 600px;
    }
  }
`;
